import { Drawer as ChakraDrawer, CloseButton, Portal } from "@chakra-ui/react";
import { forwardRef } from "react";

interface DrawerContentProps extends ChakraDrawer.ContentProps {
  portalled?: boolean;
  portalRef?: React.RefObject<HTMLElement>;
  offset?: ChakraDrawer.ContentProps["padding"];
}

export const DrawerContent = forwardRef<HTMLDivElement, DrawerContentProps>(
  function DrawerContent(props, ref) {
    const { children, portalled = true, portalRef, offset, ...rest } = props;
    return (
      <Portal disabled={!portalled} container={portalRef}>
        <ChakraDrawer.Positioner padding={offset}>
          <ChakraDrawer.Content ref={ref} {...rest} asChild={false}>
            {children}
          </ChakraDrawer.Content>
        </ChakraDrawer.Positioner>
      </Portal>
    );
  },
);

export const DrawerCloseTrigger = forwardRef<
  HTMLButtonElement,
  ChakraDrawer.CloseTriggerProps
>(function DrawerCloseTrigger(props, ref) {
  return (
    <ChakraDrawer.CloseTrigger
      position="absolute"
      top="3"
      insetEnd="3"
      {...props}
      asChild
    >
      <CloseButton size="sm" aria-label="Cerrar" ref={ref} />
    </ChakraDrawer.CloseTrigger>
  );
});

export interface DrawerRootProps
  extends Omit<ChakraDrawer.RootProps, "open" | "onOpenChange"> {
  isOpen: boolean;
  onClose: () => void;
}

export const DrawerRoot = ({
  isOpen,
  onClose,
  children,
  ...rest
}: DrawerRootProps) => (
  <ChakraDrawer.Root
    open={isOpen}
    onOpenChange={(e) => {
      if (!e.open) onClose();
    }}
    lazyMount
    unmountOnExit
    {...rest}
  >
    {children}
  </ChakraDrawer.Root>
);

export const DrawerTrigger = ChakraDrawer.Trigger;
export const DrawerFooter = ChakraDrawer.Footer;
export const DrawerHeader = ChakraDrawer.Header;
export const DrawerBody = ChakraDrawer.Body;
export const DrawerBackdrop = ChakraDrawer.Backdrop;
export const DrawerDescription = ChakraDrawer.Description;
export const DrawerTitle = ChakraDrawer.Title;
export const DrawerActionTrigger = ChakraDrawer.ActionTrigger;
